import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import {
  types as actions,
  setGatewayDetailAction
} from '../../reducers/actions';
import { GatewayService } from '../../services';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_GATEWAY_DETAIL),
    switchMap(action =>
      GatewayService.getAll(action.siteId, store).pipe(
        map(data => {
          return setGatewayDetailAction(data);
        })
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/status/getGateway.js